import type { ReactNode } from 'react';
import { Icon } from './Icon.js';

export interface EmptyStateProps {
  /** Material Symbols ligature. */
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = 'inbox', title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-lg bg-surface-alt/60 px-6 py-14 text-center">
      <Icon name={icon} size={36} className="text-muted-soft" />
      <p className="font-medium text-ink">{title}</p>
      {description ? <p className="max-w-sm text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
